"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var types = _interopRequireWildcard(require("./types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialState = {
  _client: null,
  acknowledgementDate: null,
  authenticated: false,
  company: {},
  pendingAvatar: null,
  processing: false,
  loginError: undefined,
  token: null,
  tokenChecked: false,
  user: {},
  accounts: undefined
};
var sessionReducer = function sessionReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _cloneDeep.default)(initialState);
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case types.SET_ACKNOWLEDGEMENT_DATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        acknowledgementDate: action.acknowledgementDate
      });
    case types.REQUEST_LOGIN_CHOICE:
      return _objectSpread(_objectSpread({}, state), {}, {
        accounts: action.payload
      });
    case types.REQUEST_LOGIN_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        authenticated: true,
        processing: false,
        token: action.payload.token,
        user: action.payload.user,
        accounts: undefined,
        company: action.payload.company,
        loginError: undefined
      });
    case types.SET_COMPANY:
      return _objectSpread(_objectSpread({}, state), {}, {
        company: action.payload
      });
    case types.REQUEST_LOGIN_FAILED:
      return _objectSpread(_objectSpread({}, state), {}, {
        authenticated: false,
        processing: false,
        loginError: action.message
      });
    case types.REQUEST_LOGIN:
      return _objectSpread(_objectSpread({}, state), {}, {
        processing: true,
        loginError: undefined
      });
    case types.REQUEST_POST_AVATAR:
      return _objectSpread(_objectSpread({}, state), {}, {
        user: _objectSpread(_objectSpread({}, state.user), {}, {
          avatar: action.avatar
        })
      });
    case types.UPDATE_USER:
      return _objectSpread(_objectSpread({}, state), {}, {
        user: _objectSpread(_objectSpread({}, state.user), {}, {
          [action.key]: action.value
        })
      });
    case types.UPDATE_TOKEN:
      return _objectSpread(_objectSpread({}, state), {}, {
        token: action.token
      });
    case types.SET_USER:
      return _objectSpread(_objectSpread({}, state), {}, {
        user: action.user
      });
    case types.SET_PENDING_AVATAR:
      return _objectSpread(_objectSpread({}, state), {}, {
        pendingAvatar: action.avatar
      });
    case types.PURGE_SESSION:
      return (0, _cloneDeep.default)(initialState);
    case types.SET_CLIENT:
      return _objectSpread(_objectSpread({}, state), {}, {
        _client: action._client
      });
    case (action.type.match(/^WS_.*/) || {}).input:
      return _objectSpread(_objectSpread({}, state), {}, {
        lastWSEventAt: Date.now()
      });
    case types.SET_DASHBOARD_WIDGETS:
      return _objectSpread(_objectSpread({}, state), {}, {
        dashboardWidgets: action.payload
      });
    case types.SET_DEFAULT_TAB_BAR:
      return _objectSpread(_objectSpread({}, state), {}, {
        defaultTabBarName: action.payload
      });
    default:
      return state;
  }
};
var _default = exports.default = sessionReducer;
module.exports = exports.default;